import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import Swal from 'sweetalert2';
import "../LeadsUpdatedVersion/LeadsUpdatedVersion.css"
const formatAddress = (addr) => {
  if (!addr) return "";
  const parts = [addr.address, addr.city, addr.state, addr.country, addr.pincode];
  return parts.filter(Boolean).join(", ");
};


const Customer = () => {
  const { isSidebarOpen } = useSidebar();
  const navigate = useNavigate();

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isImportOpen, setImportOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 10;
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const url = process.env.REACT_APP_LINK
  const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
  const [clickedContact, setClickedContact] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [showCustomersdetailsModal, setShwoCustomersDetailsModal] = useState(false);


  const fetchCustomers = async () => {
    try {
      const response = await fetch(`${url}/api/customer/all/${isLoggedIn.user_id}`);
      const data = await response.json();

      console.log("API response:", data);

      const customers = Array.isArray(data)
        ? data
        : data.customers || data.customer
          ? Array.isArray(data.customers) ? data.customers : [data.customer]
          : [];

      const parsedCustomers = customers.map((customer) => ({
        ...customer,
        billingAddress: typeof customer.billingAddress === 'string' ? JSON.parse(customer.billingAddress) : customer.billingAddress || {},
        shippingAddress: typeof customer.shippingAddress === 'string' ? JSON.parse(customer.shippingAddress) : customer.shippingAddress || {},
        contact: typeof customer.contact === 'string' ? JSON.parse(customer.contact) : customer.contact || [],
      }));

      setCustomers(parsedCustomers.reverse());

    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };


  useEffect(() => {
    fetchCustomers();
  }, []);

  const filteredCustomers = customers.filter((customer) =>
    (customer.customerName || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (customer.companyName || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (customer.email || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (customer.phone1 || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (customer.gstNumber || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (customer.remarks || '').toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastCustomer = currentPage * entriesPerPage;
  const indexOfFirstCustomer = indexOfLastCustomer - entriesPerPage;
  const currentCustomers = filteredCustomers.slice(indexOfFirstCustomer, indexOfLastCustomer);
  const totalPages = Math.ceil(filteredCustomers.length / entriesPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleSearch = (event) => setSearchQuery(event.target.value);
  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);
  const toggleImport = () => setImportOpen(!isImportOpen);
  const [openCardStates, setOpenCardStates] = useState({});


  const handleRefresh = () => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1000);
  };
  const toggleDetails = (customerId) => {
    setOpenCardStates((prev) => ({
      ...prev,
      [customerId]: !prev[customerId],
    }));
  };

  const handleDelete = async (customerId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "This customer will be permanently deleted!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${url}/api/customer/${customerId}`, {
            method: 'DELETE',
          });

          if (!response.ok) {
            const err = await response.json();
            throw new Error(err?.message || 'Failed to delete');
          }

          Swal.fire('Deleted!', 'Customer has been deleted.', 'success');
          setCustomers(customers.filter(c => c.id !== customerId));
        } catch (error) {
          console.error('Delete error:', error.message);
          Swal.fire('Error!', `Failed to delete customer. ${error.message}`, 'error');
        }
      }
    });
  };


  const handleEdit = (customer) => {
    console.log("Editing customer with files:", customer); // Debug log
    navigate('/edit-customer', { state: customer });
  };


  const SkeletonLoader = () => (
    <div>
      {Array(10).fill('').map((_, index) => (
        <div className="skeleton-row" key={index}>
          {[...Array(5)].map((_, i) => <div className="skeleton" key={i}></div>)}
        </div>
      ))}
    </div>
  );

  const convertToISTUtc = (utcDateString) => {
    if (!utcDateString) return "Invalid Date";

    const date = new Date(utcDateString);
    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true
    });
  };

  const handleContactClick = async (customer, contactType) => {
    try {
      const response = await fetch(`${url}/leads/update-mark/${customer.customer_id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        }
      });

      console.log(`Mark updated for lead ID: ${customer.id}`);
      if (response.ok) {
        fetchCustomers();
      }
      // Redirect based on contact type
      if (contactType === "phone") {
        window.location.href = `tel:${customer.phone1}`;
      } else if (contactType === "whatsapp") {
        const whatsappNumber = customer.phone1.replace(/\D/g, ""); // Ensure only numbers
        window.open(`https://wa.me/${whatsappNumber}`, "_blank");
      } else if (contactType === "email") {
        window.location.href = `mailto:${customer.age}`;
      }

    } catch (error) {
      console.error("Error updating mark:", error);
    }
  };

  const OpenCustomersDetails = () => {
    setShwoCustomersDetailsModal(true);
  };


  const toggleStarred = async (customer) => {
    try {
      const response = await fetch(`${url}/leads/toggle-starred/${customer.customer_id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ star: !customer.star }), // Toggle the starred value
      });

      if (response.ok) {
        const updatedLead = await response.json();
        // Update state to reflect the change
        setCustomers((prevCustomers) =>
          prevCustomers.map((l) => (l.customer_id === customer.customer_id ? { ...l, star: updatedLead.star } : l))
        );
        console.log(`Star status updated for lead ID: ${customer.customer_id}`);
      }
    } catch (error) {
      console.error("Error updating starred status:", error);
    }
  };

  const closeCustomersDetails = () => {
    setSelectedCustomerId(null);
  };

  const openCustomerDetails = () => {
    setShwoCustomersDetailsModal(true);
  };


  return (
    <>
      <Header />
      <Sidebar />
      <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="customers-header">
          <div className="customer-dropdown">
            <p className="dashboard-title" onClick={toggleDropdown}>
              All Customers <i className={`fa-solid fa-chevron-down ${isDropdownOpen ? 'rotate' : ''}`}></i>
            </p>
          </div>

          <div className="customer-warning-new-hamburger-help">
            <p className="customer-warning-text">
              <span><i className="fa-solid fa-triangle-exclamation"></i> Update GST details</span> for 520 customers
            </p>
            <div className="customer-new">
              <Link to='/add-customer'>
                <button className="oms-add-btn"><i className="fa-solid fa-plus"></i> New</button>
              </Link>
            </div>
            <div className="import-hamburger" onClick={toggleImport}>
              <i className="fa-solid fa-ellipsis-vertical"></i>
            </div>
            {isImportOpen && (
              <div className="import-ul">
                <ul>
                  <li><Link to='/customer-import'><i className="fa-solid fa-file-arrow-down"></i> Import Customers</Link></li>
                  <li><Link to='/export-customer'><i className="fa-solid fa-file-arrow-up"></i> Export Customers</Link></li>
                  <li onClick={handleRefresh}><i className="fa-solid fa-rotate"></i> Refresh List</li>
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="filter-search">
          <div className="filter-search-input">
            <input type="search" placeholder="Search..." value={searchQuery} onChange={handleSearch} />
            <i className="fa fa-search"></i>
          </div>
        </div>

        <div >
          {loading ? (
            <SkeletonLoader />
          ) : (
            <div className="lsuv-card-container">
              {currentCustomers.map((customer, index) => {
                const isCardOpen = openCardStates.hasOwnProperty(customer.customer_id)
                  ? openCardStates[customer.customer_id]
                  : false; // default to hidden


                return (
                  <div className={`card-rating `}>
                    <div className="lsuv-card" key={index}>
                      <div className="lsuv-card__header">
                        <div className="lsuv-card__row lsuv-card__row--top">
                          <div className="lsuv-card__right">
                            <span className="lsuv-card__timestamp">{convertToISTUtc(customer.createdAt)}</span>
                          </div>
                        </div>

                        <div className="lsuv-card__row lsuv-card__row--bottom">
                          <div className="lsuv-card__left">
                            <div className="lsuv-card__star-icon" onClick={() => toggleStarred(customer)}>
                              <i
                                className={customer.star ? "fa-solid fa-star starred" : "fa-regular fa-star unstarred"}
                              ></i>
                            </div>

                            {/* <div className="lsuv-card__status">
                              <span className={`lsuv-status ${customer.mark === "Read" ? "lsuv-status--read" : "lsuv-status--unread"}`}>
                                {customer.companyName}
                              </span>
                            </div> */}
                            <div className="lsuv-card__title">
                              <p>{customer.customerName}</p>

                            </div>

                          </div>

                          <div className="lsuv-card__right">
                            <div className="lsuv-card__contact-icons">
                              {
                                customer.phone1 ? <a
                                  href="#"
                                  className={`ls-card-icon ls-call ${clickedContact ? "clicked" : ""}`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleContactClick(customer, "phone");
                                  }}
                                >
                                  <i className="fas fa-phone"></i>
                                </a> : null
                              }
                              {
                                customer.email
                                  ? (
                                    <a
                                      href="#"
                                      className={`ls-card-icon ls-mail ${clickedContact ? "clicked" : ""}`}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleContactClick(customer, "email");
                                      }}
                                    >
                                      <i className="fas fa-envelope"></i>
                                    </a>
                                  )
                                  : customer.email
                                    ? (
                                      <a
                                        href="#"
                                        className={`ls-card-icon ls-mail ${clickedContact ? "clicked" : ""}`}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleContactClick(customer, "email");
                                        }}
                                      >
                                        <i className="fas fa-envelope"></i>
                                      </a>
                                    )
                                    : null
                              }
                              {
                                customer.phone1 ? <a
                                  href='#'
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={`ls-card-icon ls-whatsapp ${clickedContact ? "clicked" : ""}`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleContactClick(customer, "whatsapp");
                                  }}
                                >
                                  <i className="fab fa-whatsapp"></i>
                                </a> : null
                              }
                              <a
                                href="#"
                                className={`ls-card-icon ls-whatsapp ${clickedContact ? "clicked" : ""}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedCustomerId(customer);
                                  setShwoCustomersDetailsModal(true);
                                }}
                              >
                                <i className="fas fa-eye"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="lsuv-middle-footer">
                        <div className="lsuv-card__middle">
                          <div className="lsuv-card__address">
                            <p>{customer.billingAddress.city} {customer.billingAddress.state} {customer.billingAddress.country}</p>
                            <p>{customer.billingAddress.pincode}</p>
                          </div>

                          {
                            customer.remarks ?
                              <div className="lsuv-card__message">
                                <p><strong>Message:</strong>{customer.remarks}</p>
                              </div> : null
                          }


                        </div>
                        <div className={isCardOpen ?  'lsuv-card__footer-section-hidden':'lsuv-card__footer-section'}>
                          <div className="lsuv-card__footer-section">
                            <div className="lsuv-card__action-group">
                              <div className="lsuv-card__action">
                                <button onClick={() => handleEdit(customer)} className="lsuv-card__btn">
                                  <i className="fa-solid fa-pen"></i> Edit
                                </button>
                              </div>

                            </div>
                          </div>
                          {
                            customer.customerType ?
                              <div className="lsuv-card__source-info">
                                <p><strong>Customer Type:</strong> {customer.customerType}</p>
                              </div>
                              : null
                          }
                          {
                            customer.companyName ?
                              <div className="lsuv-card__source-info">
                                <p><strong>Customer Name:</strong> {customer.companyName}</p>
                              </div>
                              : null
                          }
                          {
                            customer.phone1 ?
                              <div className="lsuv-card__source-info">
                                <p><strong>Phone number 1:</strong> {customer.phone1}</p>
                              </div>
                              : null
                          }

                          {
                            customer.pan ?
                              <div className="lsuv-card__source-info">
                                <p><strong>PAN :</strong> {customer.pan}</p>
                              </div>
                              : null
                          }
                          {
                            customer.placeOfSupply ?
                              <div className="lsuv-card__source-info">
                                <p><strong>GST Number:</strong> {customer.placeOfSupply}</p>
                              </div>
                              : null
                          }
                          {/* {
                            customer.pan ?
                              <div className="lsuv-card__source-info">
                                <p><strong>PAN Number:</strong> {customer.pan}</p>
                              </div>
                              : null
                          } */}
                          {
                            customer.billingAddress ? (
                              <div className="lsuv-card__source-info">
                                <p>
                                  <strong>Billing Address:</strong> {formatAddress((customer.billingAddress))}
                                </p>
                              </div>
                            ) : null
                          }

                          {
                            customer.shippingAddress ? (
                              <div className="lsuv-card__source-info">
                                <p>
                                  <strong>Shipping Address:</strong> {formatAddress((customer.shippingAddress))}
                                </p>
                              </div>
                            ) : null
                          }


                          {/* {
                                        lead.enquiry_source ?
                                            <div className="lsuv-card__source-info">
                                                <p><strong>Source:</strong> {lead.enquiry_source}</p>
                                            </div>
                                            : null
                                    }
                                    {lead.borrowAmount ? (
                                        <div className="lsuv-card__source-info">
                                            <p>
                                                <strong>Borrow Amount:</strong> {numberToWords(Number(lead.borrowAmount.replace(/,/g, '')))}
                                                (₹ {formatIndianCurrency(Number(lead.borrowAmount.replace(/,/g, '')))})
                                            </p>
                                        </div>
                                    ) : null}
                                    {lead.monthlySalary ? (
                                        <div className="lsuv-card__source-info">
                                            <p>
                                                <strong>Monthly Salary:</strong> {numberToWords(Number(lead.monthlySalary.replace(/,/g, '')))}
                                                (₹ {formatIndianCurrency(Number(lead.monthlySalary.replace(/,/g, '')))})
                                            </p>
                                        </div>
                                    ) : null} */}
                        </div>

                      </div>

                      <div className="lsuv-card__meta-footer">
                        <div
                          className="lsuv-card__toggle-details"
                          onClick={() => toggleDetails(customer.customer_id)}
                        >
                          {isCardOpen ? 'Hide Details' : 'Show Details'}
                        </div>
                        <div className="connected-delete-crm">
                          <div className="crm-delete-icon" onClick={() => handleDelete(customer.id)}>
                            <i class="fa-solid fa-trash" title="Delete Customer"></i>
                          </div>
                        </div>
                      </div>









                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>

        {showCustomersdetailsModal && selectedCustomerId && (

          <div className="ls-enquiry-modal">
            <div className="ls-enquiry-modal-content">
              <div className="quotation-header">
                <h2>Customer Details</h2>
                <button className="quotation-close" onClick={closeCustomersDetails}>
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
              <div className="leads-detail-modal-body-crm">
                <div className="lead-details-list-crm">
                  <div><strong>Type of Customer:</strong> {selectedCustomerId.customerType || "N/A"}</div>
                  <div><strong>Customer Name:</strong> {selectedCustomerId.customerName || "N/A"}</div>
                  <div><strong>Display Name:</strong> {selectedCustomerId.displayName || "N/A"}</div>
                  <div><strong>Company Name:</strong> {selectedCustomerId.companyName || "N/A"}</div>
                  <div><strong>Mobile Number:</strong> {selectedCustomerId.phone1 || "N/A"}</div>
                  <div><strong>Mobile Number 2:</strong> {selectedCustomerId.phone2 || "N/A"}</div>
                  <div><strong>Email:</strong> {selectedCustomerId.email || "N/A"}</div>

                  <div><strong>PAN:</strong> {selectedCustomerId.pan || "N/A"}</div>
                  <div><strong>GST number:</strong> {selectedCustomerId.gstNumber || "N/A"}</div>
                  <div><strong>Place of Supply:</strong> {selectedCustomerId.placeOfSupply || "N/A"}</div>
                  {/* <div><strong>Contact:</strong> {selectedCustomerId.contact || "N/A"}</div> */}
                  <div><strong>Billing Address:</strong> {selectedCustomerId.billingAddress.address || "N/A"},{selectedCustomerId.billingAddress.city},{selectedCustomerId.billingAddress.state},{selectedCustomerId.billingAddress.country},{selectedCustomerId.billingAddress.pincode}</div>
                  <div><strong>Shipping Address:</strong> {selectedCustomerId.shippingAddress.address || "N/A"},{selectedCustomerId.shippingAddress.city},{selectedCustomerId.shippingAddress.state},{selectedCustomerId.shippingAddress.country},{selectedCustomerId.shippingAddress.pincode}</div>
                  <div><strong>Note:</strong> {selectedCustomerId.remarks || "N/A"}</div>

                  <div><strong>Website URL:</strong> {selectedCustomerId.website_url || "N/A"}</div>
                  <div><strong>Department:</strong> {selectedCustomerId.department || "N/A"}</div>
                  <div><strong>Designation:</strong> {selectedCustomerId.designation || "N/A"}</div>
                  <div><strong>Twitter:</strong> {selectedCustomerId.twitter || "N/A"}</div>
                  <div><strong>Skype:</strong> {selectedCustomerId.skype || "N/A"}</div>
                  <div><strong>FaceBook:</strong> {selectedCustomerId.facebook || "N/A"}</div>

                </div>
              </div>
            </div>
          </div>
        )}


        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
          {[...Array(totalPages)].map((_, index) => (
            <button key={index} onClick={() => paginate(index + 1)} className={currentPage === index + 1 ? 'active' : ''}>
              {index + 1}
            </button>
          ))}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
        </div>
      </div >
    </>
  );
};

export default Customer;
